import React, { useEffect, useState } from "react";
import { getFamilyMembersById } from "../../../services/Profile/FamilyMember/FamilyMemeberById";
import axios from "axios";
import { toast } from "react-toastify";
import { HiPencil, HiTrash, HiUserCircle, HiCheckCircle } from "react-icons/hi";
import UpdateFamilyMember from "./updateFamilyMember";
import CreateFamilyMember from "./CreateFamilyMember";

const BASE_URL = process.env.REACT_APP_API_URL;

export default function FamilyMembers() {
  const user = JSON.parse(localStorage.getItem("medarphaUser") || "{}");
  const userId = parseInt(user?.id || user?.userId || 0);

  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [showForm, setShowForm] = useState(false);
  const [editMemberData, setEditMemberData] = useState(null);

  const relationMap = {
    3: "Wife",
    4: "Brother",
    5: "Father",
    6: "Sister",
  };

  /* ================= FETCH MEMBERS ================= */
  const fetchMembers = async () => {
    setLoading(true);
    try {
      const data = await getFamilyMembersById(userId);
      if (!data || data.length === 0) {
        setMembers([]);
        setError("No family members found.");
      } else {
        setMembers(data);
        setError("");
      }
    } catch (err) {
      console.error("Fetch members error:", err);
      setError("Failed to fetch family members.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  /* ================= ADD / EDIT ================= */
  const handleAddNew = () => {
    setEditMemberData(null);
    setShowForm(true);
  };

  const handleEdit = (member) => {
    setEditMemberData(member);
    setShowForm(true);
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this member?")) return;

    const url = `${BASE_URL}Customer/FamilyMemberDelete/${id}`;
    try {
      const res = await axios.get(url);
      if (res.data?.succeeded || res.data?.message) {
        toast.success(res.data.message || "Deleted successfully");
        fetchMembers();
      } else {
        toast.error("Delete failed");
      }
    } catch (err) {
      console.error("DELETE API ERROR:", err);
      toast.error("Delete error (check console)");
    }
  };

  return (
    <div className="container mt-4">
      {/* Header with modern icon */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="text-danger mb-0 d-flex align-items-center">
          <HiUserCircle size={28} className="me-2" />
          Family Members
        </h4>
        {!showForm && (
          <button className="btn btn-danger btn-sm" onClick={handleAddNew}>
            + Add New
          </button>
        )}
      </div>

      {/* Add/Edit Form */}
      {showForm ? (
        editMemberData ? (
          <UpdateFamilyMember
            editData={editMemberData}
            userId={userId}
            onCancel={() => setShowForm(false)}
            onSuccess={() => {
              setShowForm(false);
              fetchMembers();
            }}
          />
        ) : (
          <CreateFamilyMember
            onCancel={() => setShowForm(false)}
            onSuccess={() => {
              setShowForm(false);
              fetchMembers();
            }}
          />
        )
      ) : (
        <>
          {loading && (
            <div className="text-center text-secondary">Loading family members...</div>
          )}

          {!loading && error && (
            <div className="text-center text-danger">{error}</div>
          )}

          {!loading && !error && members.length > 0 && (
            <div className="row">
              {members.map((m) => (
                <div className="col-12 mb-3" key={m.id}>
                  <div
                    style={{
                      border: m.isDefault ? "2px solid #dc3545" : "1px solid #dee2e6",
                      borderRadius: "8px",
                      padding: "12px",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                      backgroundColor: m.isDefault ? "#fff0f0" : "#fff",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {/* Left: Photo + Info */}
                    <div className="d-flex align-items-center">
                      {m.uploadPhoto ? (
                        <img
                          src={`https://admintest.medrphalabs.com/uploads/${m.uploadPhoto}`}
                          alt={m.firstName}
                          style={{
                            width: 65,
                            height: 65,
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginRight: 15,
                          }}
                        />
                      ) : (
                        <HiUserCircle
                          size={65}
                          className="text-secondary me-3"
                          style={{ borderRadius: "50%", backgroundColor: "#f0f0f0" }}
                        />
                      )}

                      <div>
                        <b className="text-primary d-flex align-items-center">
                          {m.firstName} {m.lastName || ""}
                          <span className="text-muted ms-2" style={{ fontSize: 13 }}>
                            ({m.relationName || relationMap[m.relationId] || "Unknown"})
                          </span>
                          {/* Default icon */}
                          {m.isDefault && (
                            <HiCheckCircle
                              size={18}
                              className="text-danger ms-2"
                              title="Default"
                            />
                          )}
                        </b>
                      </div>
                    </div>

                    {/* Right: Actions */}
                    <div className="d-flex align-items-center">
                      <HiPencil
                        className="text-primary me-3"
                        size={20}
                        style={{ cursor: "pointer" }}
                        title="Edit"
                        onClick={() => handleEdit(m)}
                      />
                      <HiTrash
                        className="text-danger"
                        size={20}
                        style={{ cursor: "pointer" }}
                        title="Delete"
                        onClick={() => handleDelete(m.id)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
